var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEsreact = function SvgEsreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M.45 21h23.1q.45 0 .45-.45V3.45Q24 3 23.55 3H.45Q0 3 0 3.45v17.1q0 .45.45.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD250",
    d: "M24 6H0v12h24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "m10.2 12 .3-1.8c0-.15-.15-.3-.3-.3h-.3c-.15 0-.3.15-.3.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M10.65 11.1h-.9v4.05h.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M10.65 10.65h-1.2v.45h1.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M10.8 12H8.7v.45h2.1zM10.8 13.95l-1.2-.45v-.45l1.2.45zM3.9 12l.3-1.8c0-.15-.15-.3-.3-.3h-.15c-.15 0-.3.15-.3.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M5.4 10.65q-.45 0-.45.45v3.15c0 .6.45 1.65 2.1 1.65s2.1-1.05 2.1-1.65V11.1q0-.45-.45-.45z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M7.05 12.9h-2.1v-1.95q0-.45.45-.45h1.65zM7.05 12.9h2.1v1.2c0 .6-.45 1.2-1.05 1.2s-1.05-.6-1.05-1.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M4.95 12.9h2.1v1.2c0 .6-.45 1.2-1.05 1.2s-1.05-.6-1.05-1.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M6.6 15v-2.1h-.45v2.4c.15 0 .3-.15.45-.3M5.85 15.3v-2.4H5.4V15c.15.15.3.3.45.3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M6.6 12H5.4v.45h1.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M6.6 11.1H5.4v.45h1.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M6.45 11.4h-.9v.9h.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M4.35 11.1h-.9v4.05h.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M4.5 14.85H3.3v.45h1.2zM4.5 10.65H3.3v.45h1.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M4.8 15.3H3.15v.45H4.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M10.95 14.85h-1.2v.45h1.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M10.95 15.3H9.3v.45h1.65z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M8.4 10.05H5.85v.45H8.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M7.35 8.7H6.9v1.35h.45z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M6.6 9.45c-.3 0-.6-.3-.6-.75s.3-.75.6-.75.6.3.6.75-.3.75-.6.75m0-1.05c-.15 0-.15.15-.15.3s.15.3.15.3c.15 0 .15-.15.15-.3s0-.3-.15-.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M7.5 9.45c-.3 0-.6-.3-.6-.75s.3-.75.6-.75.6.3.6.75-.3.75-.6.75m0-1.05c-.15 0-.15.15-.15.3s.15.3.15.3c.15 0 .15-.15.15-.3s-.15-.3-.15-.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M8.25 9.9c-.3 0-.6-.3-.6-.75s.3-.75.6-.75.6.3.6.75-.3.75-.6.75m0-1.05c-.15 0-.15.15-.15.3s.15.3.15.3.15-.15.15-.3c.15-.15 0-.3-.15-.3M5.85 9.9c-.3 0-.6-.3-.6-.75s.3-.75.6-.75.6.3.6.75-.3.75-.6.75m0-1.05c-.15 0-.15.15-.15.3s.15.3.15.3c.15 0 .15-.15.15-.3s-.15-.3-.15-.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M8.25 13.95v.3c0 .15-.15.3-.15.3-.15 0-.15-.15-.15-.3v-.3zm.45-.6H7.5v.75c0 .45.3.75.6.75s.6-.3.6-.75z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA0D2",
    d: "M8.1 12.45q-.45 0-.45-.45v-.45q0-.45.45-.45t.45.45V12c0 .3-.3.45-.45.45"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M7.65 12.9c0 .45-.3.75-.6.75s-.6-.3-.6-.75.3-.75.6-.75c.3.15.6.45.6.75"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M7.35 7.8H6.9v1.35h.45z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M5.85 10.05 5.4 9.6l.3-.3c.3-.3.75-.6 1.35-.6s1.05.3 1.35.6l.3.3-.45.45z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD250",
    d: "M7.2 9.6c0 .15-.15.3-.15.3-.15 0-.15-.15-.15-.3s.15-.3.15-.3c.15.15.15.15.15.3M6.45 9.6c0 .15-.15.3-.15.3-.15 0-.15-.15-.15-.3s.15-.3.15-.3c0 .15.15.15.15.3M8.1 9.6c0 .15-.15.3-.15.3-.15 0-.15-.15-.15-.3s.15-.3.15-.3c0 .15.15.15.15.3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M5.4 12H3.3v.45h2.1zM3.3 13.95l1.2-.6v-.45l-1.2.45z"
  })));
};
export default SvgEsreact;